import { Component, Input } from "@angular/core";
import { DisplayParamGroupedTreeViewDataComponent, ParamData, TreeViewSingleData } from "@otimo/highcharts-parameters";

@Component({
    selector: "parameter-list",
    templateUrl: "./parameter-list.component.html",
    imports: [DisplayParamGroupedTreeViewDataComponent]
})
export class ParameterListComponent {

    @Input() textParamDatas: ParamData[];
    @Input() treeParamDatas: ParamData[];
    @Input() vardAvParamDatas: ParamData[];
    @Input() diagnosParamDatas: ParamData[];
    @Input() externKonsultParamDatas: ParamData[];

    @Input() treeViewDatas: TreeViewSingleData[];
    @Input() vardAvViewDatas: TreeViewSingleData[];
    @Input() diagnosViewDatas: TreeViewSingleData[];
    @Input() externKonsultViewDatas: TreeViewSingleData[];

}
